<template>
  <near-by-company/>
</template>

<script>
import NearByCompany from '../components/NearByCompany/index'
export default {
  components: {NearByCompany},

}
</script>

<style>

</style>
